export class Language {
    code: string;
    text: string;
}

export class Languages {
    lang: string;
    texts: Language[] = [];

    constructor(language: string) {
        this.lang = language;

        switch (this.lang) {
            case 'it': {
                this.texts = texts_it;
                break;
            }
            default: {
                this.texts = texts_en;
                break;
            }
        }
    }

    getLanguage(code: string): string {
        let text: Language = this.texts.find((t) => { return t.code === code; });
        return (text !== undefined) ? text.text : '';
    }
}

const texts_it: Language[] = [
    {
        code: "home_access",
        text: "In questa sezione vengono racchiuse le statistiche relative ai dati degli utenti (nuovi e di ritorno) sulle location distribuite sul territorio. Vengono inoltre presentate analisi sulla singola fascia oraria / giorno della settimana."
    },
    {
        code: "home_login",
        text: "Questa sezione contiene le informazioni riguardanti i dispositivi connessi alla rete tramite login. Vengono inoltre presentate analisi sulla singola fascia oraria / giorno della settimana."
    },
    {
        code: "home_presence",
        text: "Da questa sezione si ha accesso ai dati relativi ai dispositivi percepiti dalla piattaforma in maniera anonima. Non è richiesto login. La raccolta di questa tipologia di dato grezzo avviene grazie alle tecnologia del vendor scelto per realizzare l’infrastruttura WiFi."
    },
    {
        code: "home_location",
        text: "In questa sezione è possibile accedere ai dati di localizzazione forniti dal vendor dell’infrastruttura WiFi. In particolare, tali dati vengono aggregati per zona oppure trasposti direttamente sulla mappa della singola location."
    },
    {
        code: "home_network",
        text: "Questa sezione racchiude informazioni legate alla quantità di traffico effettuata dalle varie location sia in termini di quantità che di provenienza. Per ogni location sarà possibile visualizzare i domini visitati in modalità aggregata."
    },
    {
        code: "login_realtime",
        text: "Questa sezione offre dati, in tempo reale, circa utenti, dispositivi ed alcune analisi di dettaglio, come ad esempio rapporto login/logout, durata delle sessioni e produttori dei dispositivi."
    },
    {
        code: "login_connections",
        text: "Qui vengono analizzate le connessioni effettuate dai vari dispositivi e graficate per durata in funzione dell’ora oppure del giorno o di entrambi."
    },
    {
        code: "login_connection_vendor",
        text: "Vengono mostrati i vendor dei dispositivi degli utenti che hanno effettuato una connessione."
    },
    {
        code: "login_connection_location_ranking",
        text: "Viene data visibilità in termini di utenti, nuovi utenti e connessioni alle location in cui il servizio è più utilizzato."
    },
    {
        code: "login_location_ranking",
        text: "Viene data visibilità in termini di utenti, nuovi utenti e connessioni alle location in cui il servizio è più utilizzato. Esiste una sotto-sezione dedicata al tasso di crescita della singola location."
    },
    {
        code: "login_network_io",
        text: "Questa sezione racchiude le info raccolte in termini di scambio dati da e verso la rete."
    },
    {
        code: "location_realtime",
        text: "In questa sezione è possibile accedere ai dati di localizzazione in tempo reale forniti dal vendor dell’infrastruttura WiFi successivamente analizzati."
    },
    {
        code: "location_heatmap",
        text: "In questa sezione è possibile accedere ai dati di localizzazione forniti dal vendor dell’infrastruttura WiFi successivamente analizzati, mappati sia su base tempo reale che storica dalla piattaforma Guglielmo."
    },
    {
        code: "location_zones",
        text: "In questa sezione è possibile accedere ai dati di localizzazione forniti dal vendor dell’infrastruttura WiFi. A differenza della sezione Heatmap qui i dati vengono successivamente aggregati su base zona e visualizzati in termini di dispositivi (sia su base giornaliera che settimanale) e durata visita media."
    },
    {
        code: "location_flows",
        text: "Questa sezione analizza in generale i flussi tra una o più location oppure tra diversi piani e/o zone di una singola location"
    },
    {
        code: "home_queues",
        text: "In questa sezione è possibile visualizzare le informazioni legate alle code sia in termini di quantità che di tempo."
    },
    {
        code: "home_management",
        text: "Da questa sezione si ha accesso ai dati relativi all'utilizzo della App e di SEA Pass. È inoltre possibile inviare notifiche Push e gestire i Beacon."
    },
    {
        code: "home_management_taste222",
        text: "Da questa sezione si ha accesso ai dati relativi all'utilizzo del wallet. È inoltre possibile inviare notifiche Push, gestire ed eleminare le Card e gestire i Beacon."
    },
    {
        code: "home_management_caligoohq",
        text: "Da questa sezione si ha accesso ai dati relativi all'utilizzo del wallet. È inoltre possibile inviare notifiche Push e gestire i Beacon."
    },
    {
        code: "home_isp_management",
        text: "In questa sezione è possibile gestire le Location e le Regole. È inoltre possibile inviare notifiche Push e gestire i Beacon per ogni Location."
    },
    {
        code: "home_caligoohq_management",
        text: "In questa sezione è possibile gestire le Location e le Regole. È inoltre possibile inviare notifiche Push e gestire i Beacon per ogni Location."
    },
    {
        code: "home_management_wallet_isp",
        text: "Da questa sezione si ha accesso ai dati relativi all'utilizzo del wallet. È inoltre possibile inviare notifiche Push, abilitare le Location e gestire i Beacon."
    },
    {
        code: "home_management_wallet_xfactor",
        text: "Da questa sezione si ha accesso ai dati relativi all'utilizzo del wallet. È inoltre possibile inviare notifiche Push, abilitare le Location e gestire i Beacon."
    },
    {
        code: "management",
        text: "In questa sezione è possibile consultare e gestire le informazioni legate al monitoraggio dello stato delle location, dipendente dal numero di accessi registrati."
    },
    {
        code: "management_location",
        text: "In questa sezione è possibile consultare e gestire le informazioni legate al monitoraggio dello stato delle location, dipendente dal numero di accessi registrati."
    },
    {
        code: "management_stats",
        text: "In questa sottosezione vengono mostrati i dati relativi allo stato delle location, con dettaglio su quelle etichettate come silenti e risolte."
    },
    {
        code: "management_settings",
        text: "Tramite questa sottosezione è possibile aggiornare le informazioni relative al monitoraggio dello stato delle location, come i periodi di chiusura e le email per l'invio delle notifiche."
    },
    {
        code: "home_taste222_management",
        text: "In questa sezione è possibile gestire le Location e le Regole. È inoltre possibile inviare notifiche Push e gestire i Beacon per ogni Location."
    },
    {
        code: "home_journey_management",
        text: "In questa sezione è possibile gestire le Location e le Regole. È inoltre possibile inviare notifiche Push e gestire i Beacon per ogni Location."
    },
    {
        code: "journey",
        text: "In questa sezione si ha accesso alle statistiche di utilizzo e attivazione dei journey. È inoltre possibile gestire le Location e le Regole, inviare notifiche Push e gestire i Beacon per ogni Location."
    },
    {
        code: "journey_management",
        text: "In questa sezione è possibile gestire le Location e le Regole. È inoltre possibile inviare notifiche Push e gestire i Beacon per ogni Location."
    },
    {
        code: "journey_analytics",
        text: "In questa sezione si ha accesso alle statistiche di utilizzo e attivazione dei journey."
    },
    {
        code: "wla",
        text: "Da questa sezione è possibile configurare le componenti della tua Whitelabel App."
    },
    {
        code: "account_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni Account, che permettono agli utenti di effettuare il login tramite social network o email.#Ogni app permette una sola pagina di questa tipologia nella stessa configurazione."
    },
    {
        code: "wifi_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni WiFi, che permettono di visualizzare lo stato della connessione alla rete WiFi guest associata al servizio, se presente, e di fornire all'utente una guida per effettuare il login.#Ogni app permette una sola pagina di questa tipologia nella stessa configurazione. "
    },
    {
        code: "map_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni Mappa, che permettono di visualizzare dei punti di interesse e mostrarne i dettagli.#È possibile utilizzare più pagine di questo tipo nella stessa configurazione dell'app."
    },
    {
        code: "notifications_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni Notifiche, che mostrano le notifiche ricevute dagli utenti ed il loro dettaglio.#Ogni app permette una sola pagina di questa tipologia nella stessa configurazione. Necessita del modulo Cognitive Engine."
    },
    {
        code: "webview_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni Web, che mostrano una pagina pre-configurata. Si possono inoltre aggiornare automaticamente i contenuti tramite una notifica push (questa funzionalità necessita del modulo Cognitive Engine per le notifiche).#È possibile utilizzare più pagine di questo tipo nella stessa configurazione dell'app."
    },
    {
        code: "media_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni Media, che permettono di visualizzare video caricati direttamente sulla dashboard o da link esterni.#È possibile utilizzare più pagine di questo tipo nella stessa configurazione dell'app."
    },
    {
        code: "pages_wla",
        text: "In questa pagina è possibile aggiungere e visualizzare le sezioni Page, che permettono la definizione di una lista di elementi personalizzati e mostrare il dettaglio degli stessi in varie modalità.#È possibile utilizzare più sezioni di questo tipo nella stessa configurazione dell'app."
    },
];
const texts_en: Language[] = [
    {
        code: "home_access",
        text: "This section contains users statistics (new and returning) of the active locations and analysis related to hours of the day and day of the week."
    },
    {
        code: "home_login",
        text: "Information related to logged users are presented in this section with a break down for hours of the day and days of the week."
    },
    {
        code: "home_presence",
        text: "It collects the analytics and statistics associated to the (anonymous) devices sensed by the platform without the need of a Login procedure. The collection of this data is linked with the technology deployed in the location and the type WiFi Vendor available."
    },
    {
        code: "home_location",
        text: "This section groups the analysis related to the locationing of active wireless devices. The collected data are analyzed in real-time, aggregated for venue, zone and time windows and presented with several metrics and graphs (e.g., Heatmap)."
    },
    {
        code: "home_network",
        text: "Information and analytics related to the network usage are displayed in this section for each available location. Showed analytics are related to network throughput, traffic volumes, services, used domains and data sources."
    },
    {
        code: "login_realtime",
        text: "Real-time data about logged users and devices with additional information and analysis related to login/logout rate, sessions and device vendors."
    },
    {
        code: "login_connections",
        text: "Location Ranking as a function of device connections and presented with respect to hours and/or days. "
    },
    {
        code: "login_connection_vendor",
        text: "Device vendors."
    },
    {
        code: "login_connection_location_ranking",
        text: "Location Ranking as a function of device connections and presented with respect to hours and/or days."
    },
    {
        code: "login_location_ranking",
        text: "Location Ranking based on the number of new users and connections. Furthermore, the section includes the growing rate for each single location."
    },
    {
        code: "login_network_io",
        text: "Information and statistics about Network Input and Output."
    },
    {
        code: "location_realtime",
        text: "This section contains real-time device location tracking analytics. The platform integrated raw data coming from the WiFi infrastructure. "
    },
    {
        code: "location_heatmap",
        text: "Heatmap analytics associated to the presence and the visit duration of tracked devices."
    },
    {
        code: "location_zones",
        text: "Information about tracked devices are analyzed considering available zones in the venue in terms of number of devices and visit duration."
    },
    {
        code: "location_flows",
        text: "This section contains the analysis related to device flows between available zones in each venue."
    },
    {
        code: "home_queues",
        text: "Queue analysis related to number of waiting devices and time estimation are presented."
    },
    {
        code: "home_management",
        text: "SEA Pass overview and statistics section. It includes also Beacon and Push Notification management."
    },
    {
        code: "home_management_taste222",
        text: "Wallet experience overview and statistics section. It includes also Beacon, Card and Push Notification management."
    },
    {
        code: "home_management_caligoohq",
        text: "Wallet experience overview and statistics section. It includes also Beacon and Push Notification management."
    },
    {
        code: "home_isp_management",
        text: "Location and Rules management section. It includes also Push Notification management and Beacon management for each Location."
    },
    {
        code: "home_caligoohq_management",
        text: "Location and Rules management section. It includes also Push Notification management and Beacon management for each Location."
    },
    {
        code: "home_management_wallet_isp",
        text: "Wallet experience overview and statistics section. It includes also Beacon, Location and Push Notification management."
    },
    {
        code: "home_management_wallet_xfactor",
        text: "Wallet experience overview and statistics section. It includes also Beacon, Location and Push Notification management."
    },
    {
        code: "management",
        text: "This section is about watching and managing informations related to locations' status monitoring. Locations' status depends on the number of registered users."
    },
    {
        code: "management_location",
        text: "This section is about watching and managing informations related to locations' status monitoring. Locations' status depends on the number of registered users."
    },
    {
        code: "management_stats",
        text: "This subsection shows date related to locations' status, with a detail on locations marked as silent and resolved."
    },
    {
        code: "management_settings",
        text: "This subsection is about updating informations related to locations' status, as closing days and notification emails."
    },
    {
        code: "home_taste222_management",
        text: "Location and Rules management section. It includes also Push Notification management and Beacon management for each Location."
    },
    {
        code: "home_journey_management",
        text: "Location and Rules management section. It includes also Push Notification management and Beacon management for each Location."
    },
    {
        code: "journey",
        text: "Journey experience overview and statistics section. It includes also Location and Rules management section, Push Notification management and Beacon management for each Location."
    },
    {
        code: "journey_management",
        text: "Location and Rules management section. It includes also Push Notification management and Beacon management for each Location."
    },
    {
        code: "journey_analytics",
        text: "Journey experience overview and statistics section."
    },
    {
        code: "wla",
        text: "In this section you can configure your Whitelabel App components."
    },
    {
        code: "account_wla",
        text: "This page allows to view and add Account sections, which are used to let users login through social networks or email.#Only one section of this type is allowed in an app's configuration."
    },
    {
        code: "wifi_wla",
        text: "This page allows to view and add WiFi sections, which show the status of the connection to the service's Guest WiFi network, if present, and to provide a guide to help users connect to the network.#Only one section of this type is allowed in an app's configuration."
    },
    {
        code: "map_wla",
        text: "This page allows to view and add Map sections, which show points of interest and their details.#It is possible to have multiple sections of this type in an app's configuration."
    },
    {
        code: "notifications_wla",
        text: "This page allows to view and add Notifications sections, which show incoming push notifications.#Only one section of this type is allowed in an app's configuration. The Cognitive Engine module is required to use this feature."
    },
    {
        code: "webview_wla",
        text: "This page allows to view and add Webview sections, which load content from a configured website. It is also possible to adapt the content dynamically as a result of an incoming push notification (this feature requires the Cognitive Engine module). It is possible to have multiple sections of this type in an app's configuration."
    },
    {
        code: "media_wla",
        text: "This page allows to view and add Media sections, where videos can be played.#It is possible to have multiple sections of this type in an app's configuration."
    },
    {
        code: "pages_wla",
        text: "This page allows to view and add Page sections, which display a list of custom, browsable items.#It is possible to have multiple sections of this type in an app's configuration."
    },
];